import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Facet } from 'src/app/models/walai';
@Component({
  selector: 'app-more-filter-dialog',
  // standalone: true,
  // imports: [],
  templateUrl: './more-filter-dialog.component.html',
  styleUrl: './more-filter-dialog.component.css'
})
export class MoreFilterDialogComponent {
  @Input() filters : Array<Facet> = [];
  @Input() filterName: string = '';
  sortOption: 'alphabetical' | 'count' = 'alphabetical';

  filters2:  Array<Facet> = [];

 
  constructor(public activeModal: NgbActiveModal) {
    // Initialize the filters if not provided
   
  }

  ngOnInit(): void {

    this.filters2 = this.filters;
    this.sortFilters();
  }

  changeSortOption(option: 'alphabetical' | 'count'): void {
    this.sortOption = option;
    this.sortFilters();
  }

  sortFilters(): void {
    if (this.sortOption === 'alphabetical') {
      this.filters2.sort((a, b) => a.name.localeCompare(b.name));
    } else if (this.sortOption === 'count') {
      this.filters2.sort((a, b) => (Number(b.count) || 0) - (Number(a.count) || 0));
    }

  }

  // Click event handler  และส่งค่ากลับไปยัง parent component
  onFilterClick(filter: Facet): void {
    this.activeModal.close(filter);
  }

 
}